export default "__VITE_ASSET__Ln8f9vsy__"